import createTableStore from "ds/components/Table/store/useTableStore";

import { PLUGINS_COLUMN_CONFIG, PLUGINS_COLUMNS_STORAGE_KEY } from "./constants";

export const usePluginsTableStore = createTableStore({
  storageKey: PLUGINS_COLUMNS_STORAGE_KEY,
  config: PLUGINS_COLUMN_CONFIG,
});
